import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { hiddenFormField, SelectOptionFields, pluginCode } from 'drapcode-constant';
import { processSteps } from '../collectionForm/utils';
import {
  getCollectionFields,
  getCollectionOptionsForSelect,
  getExternalAPIOptionsForSelect,
  getInstalledPlugins,
  getTypesenseCollectionOptionsForSelect,
} from '../pluginComponentApi';

const getFieldOptions = (collection) => {
  let options = [];
  if (collection && collection.fields) {
    const innerFields = collection.fields.filter((field) =>
      SelectOptionFields.includes(field.type),
    );
    options = innerFields.map((field) => {
      return { value: field.fieldName, name: field.fieldTitle.en };
    });
  }
  return options;
};

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, collections, bindCollectionOptions, token, externalApis, version } = opt;
  let externalAPIList = externalApis.filter(
    (externalAPI) =>
      externalAPI.responseDataMapping &&
      externalAPI.responseDataMapping.selectedCollectionName !== '',
  );
  let {
    collection: pageCollection,
    session,
    sessionTenant,
    sessionUserSettings,
    sessionSubTenant,
  } = bindCollectionOptions;

  let innerFieldOptions = [];
  if (pageCollection) {
    const { collectionId } = pageCollection;
    pageCollection = collections.find((col) => col.collectionName === collectionId);
    innerFieldOptions = getFieldOptions(pageCollection);
  }
  let userCollection, tenantCollection, userSettingsCollection, subTenantCollection;
  let userFieldOptions,
    tenantFieldOptions = [],
    userSettingsFieldOptions = [],
    subTenantFieldOptions = [];
  if (session) {
    userCollection = collections.find((col) => col.collectionName === 'user');
    userFieldOptions = getFieldOptions(userCollection);
  }
  if (sessionTenant) {
    const { collectionId } = sessionTenant;
    tenantCollection = collections.find((col) => col.collectionName === collectionId);
    tenantFieldOptions = getFieldOptions(tenantCollection);
  }
  if (sessionUserSettings) {
    const { collectionId } = sessionUserSettings;
    userSettingsCollection = collections.find((col) => col.collectionName === collectionId);
    userSettingsFieldOptions = getFieldOptions(userSettingsCollection);
  }
  if (sessionSubTenant) {
    const { collectionId } = sessionSubTenant;
    subTenantCollection = collections.find((col) => col.collectionName === collectionId);
    subTenantFieldOptions = getFieldOptions(subTenantCollection);
  }
  const installedPlugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  const multiTenantPlugin =
    installedPlugins &&
    installedPlugins.find((plugin) => plugin.code === pluginCode.MULTI_TENANT_SAAS);
  const hasMultiTenantPlugin = !!multiTenantPlugin;

  const typesenseSearchPlugin =
    installedPlugins &&
    installedPlugins.find((plugin) => plugin.code === pluginCode.TYPESENSE_SEARCH);

  const refTypeFields = [
    'innerFields',
    'userFields',
    'tenantFields',
    'userSettingsFields',
    'subTenantFields',
  ];
  const style = document.createElement('style');
  style.innerHTML = `
  .checkmark::after {
    left: 4px;
    top: 4px;
  }

  checkbox {
    all: unset;
  }

  select option:first-child {
    color: grey;
  }

  select.empty {
    color: grey;
  }

  select option[disabled]:first-child {
    display: none;
  }

  input[type=webconnect-text] {
    display: block;
  }

  input[type=webconnect-link] {
    display: block;
  }
  `;
  document.head.appendChild(style);
  if (collections || innerFieldOptions) {
    traitManager.addType('browser-storage-setter-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div id="URL" class="settings--progress">
      ${
        collections || pageCollection
          ? `
          <div class="gjs-container">
            <div class="gjs-row mx-auto">
              <div class="badge badge-default cms--progress--step-1">
                <i class="wb webconnect"></i>
                <span class="step--desc">Step 1: Select Get Content From</span>
              </div>
            </div>
            <div class="gjs-row">
            <div class="gjs-label-wrp d-none">
            <div class="gjs-label" title="Get Content">Get Content</div>
          </div>
            <div id="select-getContentFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getContentFrom">
              <div class="gjs-field">
                <select class="select-getContentFrom form-control form-control-sm options-light">
                  <option value="">- Get Content -</option>
                  ${
                    collections
                      ? `
                      <option value="collections">Get Data From Collection</option>
                            `
                      : ''
                  }
                  ${
                    pageCollection
                      ? `
                      <option value="innerFields">Get Data From ${pageCollection.collectionTitle} Field</option>
                            `
                      : ''
                  }
                  ${
                    externalAPIList
                      ? `
                      <option value="externalApiResponse">Get Data From External API Response</option>
                            `
                      : ''
                  }
                      
                </select>
                </div>
              </div>
            </div>
          </div>
          `
          : ''
      }
    <div class="gjs-container cms-data-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select Collection / Field</span>
        </div>
        <div class="cms-create-collection-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
        </div>
        <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
          <div id="select-field-div" style="display: none" class="gjs-field">
            <select class="selectField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-external-api-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select External API</span>
        </div>
        <div class="create-external-api-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}externalapi/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create ExternalAPI
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-external-api-label" title="External API">External API</div>
        </div>
        <div id="select-external-api-div" class="gjs-field-wrp gjs-field-wrp--select-external-api">
          <div id="select-external-api-field-div" style="display: none" class="gjs-field">
            <select class="selectExternalApiField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-filter-container pb-0" style="display: none">
      <div class="gjs-row mx-auto pb-0">
        <div class="badge badge-default cms--progress--step-3">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 3: Select Filter (Optional)</span>
        </div>
      </div>
    </div>
     <div class="form-group filter-div" style="display: none">
        <select class="filter-select form-control form-control-sm options-light">
        </select>
     </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectExternalApiField = el.querySelector('.selectExternalApiField');
        const selectGetContentFrom = el.querySelector('.select-getContentFrom');
        const cmsFilterContainer = el.querySelector('.cms-filter-container');
        const cmsExternalAPIContainer = el.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = el.querySelector('.create-external-api-container');

        selectGetContentFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          let optionHtml = `<option value="">None</option>`;
          // cmsCreateCollectionContainer.style.display = 'block';
          // cmsDataContainer.style.display = 'block';
          selectFieldDiv.style.display = 'block';

          if (selectGetContentFrom.value === 'externalApiResponse') {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'block';
            cmsExternalAPIContainer.style.display = 'block';
          } else {
            cmsCreateCollectionContainer.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }

          if (['collections', 'browserSession'].includes(selectGetContentFrom.value)) {
            optionHtml = getCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'typesenseCollection') {
            optionHtml = getTypesenseCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          } else if (selectGetContentFrom.value === 'innerFields') {
            optionHtml = `<option value="" selected>- Select Field -</option>`;
            optionHtml += `${innerFieldOptions
              .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
              .join('')}`;
          } else {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            selectFieldDiv.style.display = 'none';
            cmsFilterContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }
          selectField.innerHTML = optionHtml;
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectField');
        const filterDiv = elInput.querySelector('.filter-div');
        const filterSelect = elInput.querySelector('.filter-select');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsFilterContainer = document.querySelector('.cms-filter-container');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          if (selectGetContentFrom.value === 'innerFields') {
            cmsDataLabel.innerHTML = 'Collection Field';
            component.set('finderUuid', '');
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionName', '');
          } else {
            cmsDataLabel.innerHTML = 'Collection';
          }
        }

        let selectedCollection;
        let collectionName;
        if (selectGetContentFrom.value && select.value) {
          if (selectGetContentFrom.value === 'innerFields') {
            filterDiv.style.display = 'none';
            filterSelect.innerHTML = '';
            const selectedRefField = pageCollection.fields.find(
              (field) => field.fieldName === select.value,
            );
            const { refCollection, fieldName } = selectedRefField;
            collectionName = refCollection ? refCollection.collectionName : '';
            component.set('fieldName', fieldName || '');
            component.set('finderUuid', '');
            component.removeTrait('finderUuid');
            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (sessionDataPathTrait) {
              component.removeTrait('sessionDataPath');
            }
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
          } else if (['collections', 'typesenseCollection'].includes(selectGetContentFrom.value)) {
            component.set('fieldName', '');
            collectionName = select.value;
            selectedCollection = collections.find((coll) => collectionName === coll.collectionName);
            const finderOptions = selectedCollection.finders.map((finder) => {
              return { value: finder.uuid, name: finder.name };
            });
            const findAllFinder = selectedCollection.finders.find(
              (finder) => finder.name === 'Find All' || finder.name === 'All Items',
            ).uuid;
            const filterTrait = component.getTrait('finderUuid');
            if (collectionName) {
              component.set('finderUuid', findAllFinder);
            } else {
              component.set('finderUuid', '');
            }
            if (selectGetContentFrom.value === 'typesenseCollection') {
              component.set('collectionFrom', 'typesenseCollection');
            }

            if (!filterTrait) {
              const traitOpts = {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              };
              component.addTrait(traitOpts, { at: component.getTraitIndex('collectionName') + 1 });
            } else {
              filterTrait.set('options', finderOptions);
            }
          }
          // else if (selectGetContentFrom.value === 'browserSession') {
          //   component.set('fieldName', '');
          //   component.set('finderUuid', '');
          //   component.set('collectionFrom', 'browserSession');
          //   collectionName = select.value;
          //   selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

          //   const filterTrait = component.getTrait('finderUuid');
          //   if (filterTrait) {
          //     component.removeTrait('finderUuid');
          //   }

          //   const sessionDataPathTrait = component.getTrait('sessionDataPath');
          //   if (!sessionDataPathTrait) {
          //     component.addTrait(
          //       {
          //         type: 'text',
          //         label: 'Data Path',
          //         name: 'sessionDataPath',
          //         placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
          //         changeProp: 1,
          //       },
          //       { at: component.getTraitIndex('collectionName') + 1 },
          //     );
          //   }
          // }

          const finderUuid = component.get('finderUuid');
          if (finderUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else {
            cmsFilterContainer.style.display = 'none';
          }

          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else if (
          selectGetContentFrom.value &&
          selectGetContentFrom.value === 'externalApiResponse'
        ) {
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', 'externalAPIResponse');
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          selectExternalApiFieldDiv.style.display = 'block';
          const selectedExternalAPI = selectExternalApiField.value
            ? externalAPIList.find(
                (externalAPI) => externalAPI.uuid === selectExternalApiField.value,
              )
            : '';
          const externalAPIResponseCollection = selectedExternalAPI
            ? selectedExternalAPI.responseDataMapping.selectedCollectionName
            : '';
          collectionName = externalAPIResponseCollection ? externalAPIResponseCollection : '';
          selectedCollection = collections.find((coll) => collectionName === coll.collectionName);

          if (selectedExternalAPI) {
            selectedCollection.responseDataMapping =
              selectedExternalAPI.responseDataMapping.selectedMapping;
            selectedCollection.bodyDataFrom = selectedExternalAPI.bodyDataFrom;
            selectedCollection.sendFormData = selectedExternalAPI.sendFormData
              ? selectedExternalAPI.sendFormData
              : false;
            selectedCollection.externalApiId = selectedExternalAPI.uuid;
            let externalAPIData = {
              externalApiId: selectedExternalAPI.uuid,
              responseDataMapping: selectedExternalAPI.responseDataMapping.selectedMapping,
              bodyDataFrom: selectedExternalAPI.bodyDataFrom,
              sendFormData: selectedExternalAPI.sendFormData
                ? selectedExternalAPI.sendFormData
                : false,
            };
            component.set('externalApiData', externalAPIData);
          } else {
            if (selectedCollection) {
              selectedCollection.externalApiId = '';
            }
          }

          const responseDataMappingFields = [];
          if (
            selectedExternalAPI.responseDataMapping &&
            selectedExternalAPI.responseDataMapping.selectedMapping
          ) {
            component.set(
              'externalAPIResponseDataMapping',
              selectedExternalAPI.responseDataMapping.selectedMapping,
            );
            selectedCollection.fields.forEach((element) => {
              if (hiddenFormField.includes(element.fieldName)) {
                responseDataMappingFields.push(element);
              }
              if (
                selectedExternalAPI.responseDataMapping.selectedMapping[element.fieldName] &&
                !element.fieldName.startsWith('_')
              ) {
                responseDataMappingFields.push(element);
              }
            });
          }

          if (responseDataMappingFields && selectedCollection) {
            selectedCollection.fields = responseDataMappingFields;
            component.set('externalAPIResponseDataMappingFields', responseDataMappingFields);
          }
          cmsFilterContainer.style.display = 'none';
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else {
          cmsDataLabel.innerHTML = '';
          component.set('collectionName', '');
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', '');
          component.set('externalAPIResponseDataMapping', '');
          component.set('externalApiData', '');
          component.set('externalAPIResponseDataMappingFields', '');

          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }

          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (!select.value && selectGetContentFrom.value) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            cmsFilterContainer.style.display = 'none';
          }
        }
      },
      async onUpdate({ elInput, component }) {
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');

        const collectionName = component.get('collectionName');
        const fieldName = component.get('fieldName');
        const finderUuid = component.get('finderUuid');
        let selectedCollection = component.get('selectedCollectionData');
        const collectionFrom = component.get('collectionFrom');
        let selectedExternalApiData = component.get('externalApiData');

        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const cmsFilterContainer = elInput.querySelector('.cms-filter-container');

        const cmsExternalAPIContainer = elInput.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = elInput.querySelector(
          '.create-external-api-container',
        );
        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (collectionName && !selectedCollection) {
          const response = await getCollectionFields(collectionName, collections);
          selectedCollection = response;
        }

        if (selectedCollection) {
          if (selectedExternalApiData) {
            if (
              !selectedCollection['externalApiId'] &&
              selectedExternalApiData.hasOwnProperty('externalApiId')
            ) {
              selectedCollection.externalApiId = selectedExternalApiData.externalApiId;
            }
            if (
              !selectedCollection['responseDataMapping'] &&
              selectedExternalApiData.hasOwnProperty('responseDataMapping')
            ) {
              selectedCollection.responseDataMapping = selectedExternalApiData.responseDataMapping;
            }
            if (
              !selectedCollection['bodyDataFrom'] &&
              selectedExternalApiData.hasOwnProperty('bodyDataFrom')
            ) {
              selectedCollection.bodyDataFrom = selectedExternalApiData.bodyDataFrom;
            }
            if (
              !selectedCollection['sendFormData'] &&
              selectedExternalApiData.hasOwnProperty('sendFormData')
            ) {
              selectedCollection.sendFormData = selectedExternalApiData.sendFormData;
            }
          }
          let collectionDataStr = selectedCollection ? JSON.stringify(selectedCollection) : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollection);
          component.set('selectedCollectionStr', collectionDataStr.toString());
        }

        if (fieldName && collectionName) {
          selectGetContentFrom.value = `innerFields`;
          let optionHtml = `<option value="" >- Select Field -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'none';
          optionHtml += `${innerFieldOptions
            .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = fieldName;
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid && collectionFrom === 'typesenseCollection') {
          selectGetContentFrom.value = `typesenseCollection`;
          let optionHtml = `<option value="">- Select Typesense Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getTypesenseCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollection
            ? selectedCollection.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid) {
          selectGetContentFrom.value = `collections`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollection
            ? selectedCollection.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }
          selectExternalApiField.value = '';
        }
        // else if (collectionName && collectionFrom === 'browserSession') {
        //   selectGetContentFrom.value = `browserSession`;
        //   let optionHtml = `<option value="">- Select Collection -</option>`;
        //   selectFieldDiv.style.display = 'block';
        //   cmsDataContainer.style.display = 'block';
        //   cmsCreateCollectionContainer.style.display = 'block';
        //   cmsFilterContainer.style.display = 'block';
        //   optionHtml = getCollectionOptionsForSelect(collections);
        //   selectField.innerHTML = optionHtml;
        //   selectField.value = collectionName;
        //   const filterTrait = component.getTrait('finderUuid');
        //   if (filterTrait) {
        //     component.removeTrait('finderUuid');
        //   }

        //   const sessionDataPathTrait = component.getTrait('sessionDataPath');
        //   if (!sessionDataPathTrait) {
        //     component.addTrait(
        //       {
        //         type: 'text',
        //         label: 'Data Path',
        //         name: 'sessionDataPath',
        //         placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
        //         changeProp: 1,
        //       },
        //       { at: component.getTraitIndex('collectionName') + 1 },
        //     );
        //   }
        //   selectExternalApiField.value = '';
        // }
        else if (collectionName && collectionFrom === 'externalAPIResponse') {
          selectGetContentFrom.value = `externalApiResponse`;
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';

          selectExternalApiFieldDiv.style.display = 'block';
          cmsExternalAPIContainer.style.display = 'block';
          cmsCreateExternalAPIContainer.style.display = 'block';

          selectField.value = collectionName;

          selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          selectExternalApiField.value = selectedCollection ? selectedCollection.externalApiId : '';
        }

        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsDataLabel.innerHTML = selectGetContentFrom.value
            ? selectGetContentFrom.value === 'collections'
              ? 'Collection'
              : selectGetContentFrom.value === 'typesenseCollection'
              ? 'Typesense Collection'
              : 'Collection Field'
            : '';

          if (collectionName || fieldName || selectField.value || selectExternalApiField.value) {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }

            if (collectionName && finderUuid && collectionFrom !== 'externalAPIResponse') {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'block';
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'none';
            }
          } else {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepTwo');
            }
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          cmsDataLabel.innerHTML = '';
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';
          cmsCreateExternalAPIContainer.style.display = 'none';
          cmsExternalAPIContainer.style.display = 'none';
        }
      },
    });

    traitManager.addType('data-table-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div id="URL" class="settings--progress">
      ${
        collections || pageCollection || session || sessionTenant
          ? `
          <div class="gjs-container">
            <div class="gjs-row mx-auto">
              <div class="badge badge-default cms--progress--step-1">
                <i class="wb webconnect"></i>
                <span class="step--desc">Step 1: Select Get Content From</span>
              </div>
            </div>
            <div class="gjs-row">
            <div class="gjs-label-wrp d-none">
            <div class="gjs-label" title="Get Content">Get Content</div>
          </div>
            <div id="select-getContentFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getContentFrom">
              <div class="gjs-field">
                <select class="select-getContentFrom form-control form-control-sm options-light">
                  <option value="">- Get Content -</option>
                  ${
                    collections
                      ? `
                      <option value="collections">Get Data From Collection</option>
                            `
                      : ''
                  }
                   ${
                     typesenseSearchPlugin
                       ? `
                      <option value="typesenseCollection">Get Data From Typesense</option>
                            `
                       : ''
                   }
                  ${
                    pageCollection
                      ? `
                      <option value="innerFields">Get Data From ${pageCollection.collectionTitle} Field</option>
                            `
                      : ''
                  }
                  ${
                    session
                      ? `
                      <option value="userFields">Get Data From Logged In User Field</option>
                            `
                      : ''
                  }
                  ${
                    sessionTenant && hasMultiTenantPlugin
                      ? `
                      <option value="tenantFields">Get Data From ${sessionTenant.collectionTitle} Field</option>
                            `
                      : ''
                  }
                  ${
                    sessionUserSettings && hasMultiTenantPlugin
                      ? `
                      <option value="userSettingsFields">Get Data From ${sessionUserSettings.collectionTitle} Field</option>
                            `
                      : ''
                  }
                      ${
                        sessionSubTenant && hasMultiTenantPlugin
                          ? `
                      <option value="subTenantFields">Get Data From ${sessionSubTenant.collectionTitle} Field</option>
                            `
                          : ''
                      }
                  ${
                    externalAPIList
                      ? `
                      <option value="externalApiResponse">Get Data From External API Response</option>
                            `
                      : ''
                  }
                  <option value="browserSession">Get Data From Browser Session</option>
                </select>
                </div>
              </div>
            </div>
          </div>
          `
          : ''
      }

    <div class="gjs-container cms-data-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select Collection / Field</span>
        </div>
        <div class="cms-create-collection-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
        </div>
        <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
          <div id="select-field-div" style="display: none" class="gjs-field">
            <select class="selectField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-external-api-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select External API</span>
        </div>
        <div class="create-external-api-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}externalapi/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create ExternalAPI
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-external-api-label" title="External API">External API</div>
        </div>
        <div id="select-external-api-div" class="gjs-field-wrp gjs-field-wrp--select-external-api">
          <div id="select-external-api-field-div" style="display: none" class="gjs-field">
            <select class="selectExternalApiField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-filter-container pb-0" style="display: none">
      <div class="gjs-row mx-auto pb-0">
        <div class="badge badge-default cms--progress--step-3">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 3: Select Filter (Optional)</span>
        </div>
      </div>
    </div>
     <div class="form-group filter-div" style="display: none">
        <select class="filter-select form-control form-control-sm options-light">
        </select>
     </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectExternalApiField = el.querySelector('.selectExternalApiField');
        const selectGetContentFrom = el.querySelector('.select-getContentFrom');
        const cmsFilterContainer = el.querySelector('.cms-filter-container');
        const cmsExternalAPIContainer = el.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = el.querySelector('.create-external-api-container');

        selectGetContentFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          let optionHtml = `<option value="">None</option>`;
          selectFieldDiv.style.display = 'block';

          if (selectGetContentFrom.value === 'externalApiResponse') {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'block';
            cmsExternalAPIContainer.style.display = 'block';
          } else {
            cmsCreateCollectionContainer.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }

          if (['collections', 'browserSession'].includes(selectGetContentFrom.value)) {
            optionHtml = getCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'typesenseCollection') {
            optionHtml = getTypesenseCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          } else if (refTypeFields.includes(selectGetContentFrom.value)) {
            let fieldsOptions = [];
            if (selectGetContentFrom.value === 'innerFields') {
              fieldsOptions = innerFieldOptions;
            } else if (selectGetContentFrom.value === 'userFields') {
              fieldsOptions = userFieldOptions;
            } else if (selectGetContentFrom.value === 'tenantFields') {
              fieldsOptions = tenantFieldOptions;
            } else if (selectGetContentFrom.value === 'userSettingsFields') {
              fieldsOptions = userSettingsFieldOptions;
            } else if (selectGetContentFrom.value === 'subTenantFields') {
              fieldsOptions = subTenantFieldOptions;
            }
            optionHtml = `<option value="" selected>- Select Field -</option>`;
            optionHtml += `${fieldsOptions
              .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
              .join('')}`;
          } else {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            selectFieldDiv.style.display = 'none';
            cmsFilterContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }
          selectField.innerHTML = optionHtml;
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectField');
        const filterDiv = elInput.querySelector('.filter-div');
        const filterSelect = elInput.querySelector('.filter-select');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsFilterContainer = document.querySelector('.cms-filter-container');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          if (refTypeFields.includes(selectGetContentFrom.value)) {
            cmsDataLabel.innerHTML = 'Collection Field';
            component.set('finderUuid', '');
            component.set('collectionFrom', '');
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            component.set('fieldName', '');
            component.set('finderUuid', '');
            component.set('collectionName', '');
          } else {
            cmsDataLabel.innerHTML = 'Collection';
          }
        }

        let selectedCollectionData;
        let collectionName;

        if (selectGetContentFrom.value && select.value) {
          if (refTypeFields.includes(selectGetContentFrom.value)) {
            filterDiv.style.display = 'none';
            filterSelect.innerHTML = '';
            let collection;
            if (selectGetContentFrom.value === 'innerFields') {
              collection = pageCollection;
            } else if (selectGetContentFrom.value === 'userFields') {
              collection = userCollection;
            } else if (selectGetContentFrom.value === 'tenantFields') {
              collection = tenantCollection;
            } else if (selectGetContentFrom.value === 'userSettingsFields') {
              collection = userSettingsCollection;
            } else if (selectGetContentFrom.value === 'subTenantFields') {
              collection = subTenantCollection;
            }
            const selectedRefField = collection.fields.find(
              (field) => field.fieldName === select.value,
            );
            const { refCollection, fieldName } = selectedRefField;
            collectionName = refCollection ? refCollection.collectionName : '';
            component.set('fieldName', fieldName || '');
            component.set('finderUuid', '');
            component.set('collectionFrom', selectGetContentFrom.value);
            component.removeTrait('finderUuid');
            const sessionDataPathTrait = component.getTrait('sessionDataPath');
            if (sessionDataPathTrait) {
              component.removeTrait('sessionDataPath');
            }
            const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
            if (hideWhenEmptyTrait) {
              component.set('hideWhenEmpty', '');
              component.removeTrait('hideWhenEmpty');
            }
            selectedCollectionData = collections.find(
              (coll) => collectionName === coll.collectionName,
            );
          } else if (['collections', 'typesenseCollection'].includes(selectGetContentFrom.value)) {
            component.set('fieldName', '');
            collectionName = select.value;
            selectedCollectionData = collections.find(
              (coll) => collectionName === coll.collectionName,
            );
            const finderOptions = selectedCollectionData
              ? selectedCollectionData.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            const findAllFinder = selectedCollectionData
              ? selectedCollectionData.finders.find(
                  (finder) => finder.name === 'Find All' || finder.name === 'All Items',
                ).uuid
              : '';
            const filterTrait = component.getTrait('finderUuid');
            if (collectionName) {
              component.set('finderUuid', findAllFinder);
            } else {
              component.set('finderUuid', '');
            }
            if (selectGetContentFrom.value === 'typesenseCollection')
              component.set('collectionFrom', 'typesenseCollection');

            if (!filterTrait) {
              component.addTrait(
                {
                  type: 'select',
                  label: false,
                  name: 'finderUuid',
                  options: finderOptions,
                  changeProp: 1,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            } else {
              filterTrait.set('options', finderOptions);
            }

            const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
            if (!hideWhenEmptyTrait) {
              component.addTrait(
                {
                  type: 'checkbox',
                  label: 'Hide When Empty',
                  name: 'hideWhenEmpty',
                },
                { at: component.getTraitIndex('enableMultiSelect') + 1 },
              );
            }
          }
          //  else if (selectGetContentFrom.value === 'browserSession') {
          //   component.set('fieldName', '');
          //   component.set('finderUuid', '');
          //   component.set('collectionFrom', 'browserSession');
          //   collectionName = select.value;
          //   selectedCollectionData = collections.find(
          //     (coll) => collectionName === coll.collectionName,
          //   );

          //   const filterTrait = component.getTrait('finderUuid');
          //   if (filterTrait) {
          //     component.removeTrait('finderUuid');
          //   }
          //   const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
          //   if (hideWhenEmptyTrait) {
          //     component.set('hideWhenEmpty', '');
          //     component.removeTrait('hideWhenEmpty');
          //   }
          //   const sessionDataPathTrait = component.getTrait('sessionDataPath');
          //   if (!sessionDataPathTrait) {
          //     component.addTrait(
          //       {
          //         type: 'text',
          //         label: 'Data Path',
          //         name: 'sessionDataPath',
          //         placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
          //         changeProp: 1,
          //       },
          //       { at: component.getTraitIndex('collectionName') + 1 },
          //     );
          //   }
          // }

          const finderUuid = component.get('finderUuid');
          const sessionDataPath = component.get('sessionDataPath');
          if (finderUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else if (sessionDataPath) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else {
            cmsFilterContainer.style.display = 'none';
          }

          let collectionDataStr = selectedCollectionData
            ? JSON.stringify(selectedCollectionData)
            : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollectionData);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else if (
          selectGetContentFrom.value &&
          selectGetContentFrom.value === 'externalApiResponse'
        ) {
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', 'externalAPIResponse');
          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }
          const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
          if (hideWhenEmptyTrait) {
            component.set('hideWhenEmpty', '');
            component.removeTrait('hideWhenEmpty');
          }
          selectExternalApiFieldDiv.style.display = 'block';
          const selectedExternalAPI = selectExternalApiField.value
            ? externalAPIList.find(
                (externalAPI) => externalAPI.uuid === selectExternalApiField.value,
              )
            : '';
          const externalAPIResponseCollection = selectedExternalAPI
            ? selectedExternalAPI.responseDataMapping.selectedCollectionName
            : '';
          collectionName = externalAPIResponseCollection ? externalAPIResponseCollection : '';
          selectedCollectionData = collections.find(
            (coll) => collectionName === coll.collectionName,
          );

          if (selectedExternalAPI) {
            selectedCollectionData.responseDataMapping =
              selectedExternalAPI.responseDataMapping.selectedMapping;
            selectedCollectionData.bodyDataFrom = selectedExternalAPI.bodyDataFrom;
            selectedCollectionData.sendFormData = selectedExternalAPI.sendFormData
              ? selectedExternalAPI.sendFormData
              : false;
            selectedCollectionData.externalApiId = selectedExternalAPI.uuid;
            let externalAPIData = {
              externalApiId: selectedExternalAPI.uuid,
              responseDataMapping: selectedExternalAPI.responseDataMapping.selectedMapping,
              bodyDataFrom: selectedExternalAPI.bodyDataFrom,
              sendFormData: selectedExternalAPI.sendFormData
                ? selectedExternalAPI.sendFormData
                : false,
            };
            component.set('externalApiData', externalAPIData);
          } else {
            if (selectedCollectionData) {
              selectedCollectionData.externalApiId = '';
            }
          }

          const responseDataMappingFields = [];
          if (
            selectedExternalAPI.responseDataMapping &&
            selectedExternalAPI.responseDataMapping.selectedMapping
          ) {
            component.set(
              'externalAPIResponseDataMapping',
              selectedExternalAPI.responseDataMapping.selectedMapping,
            );
            selectedCollectionData.fields.forEach((element) => {
              if (hiddenFormField.includes(element.fieldName)) {
                responseDataMappingFields.push(element);
              }
              if (
                selectedExternalAPI.responseDataMapping.selectedMapping[element.fieldName] &&
                !element.fieldName.startsWith('_')
              ) {
                responseDataMappingFields.push(element);
              }
            });
          }

          if (responseDataMappingFields && selectedCollectionData) {
            selectedCollectionData.fields = responseDataMappingFields;
            component.set('externalAPIResponseDataMappingFields', responseDataMappingFields);
          }
          cmsFilterContainer.style.display = 'none';
          let collectionDataStr = selectedCollectionData
            ? JSON.stringify(selectedCollectionData)
            : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollectionData);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else {
          cmsDataLabel.innerHTML = '';
          component.set('collectionName', '');
          component.set('fieldName', '');
          component.set('finderUuid', '');
          component.set('collectionFrom', '');
          component.set('externalAPIResponseDataMapping', '');
          component.set('externalApiData', '');
          component.set('externalAPIResponseDataMappingFields', '');
          component.set('hideWhenEmpty', '');

          const filterTrait = component.getTrait('finderUuid');
          if (filterTrait) {
            component.removeTrait('finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('sessionDataPath');
          }
          const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
          if (hideWhenEmptyTrait) {
            component.set('hideWhenEmpty', '');
            component.removeTrait('hideWhenEmpty');
          }
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (!select.value && selectGetContentFrom.value) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            cmsFilterContainer.style.display = 'none';
          }
        }
      },
      async onUpdate({ elInput, component }) {
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');

        const collectionName = component.get('collectionName');
        const fieldName = component.get('fieldName');
        const finderUuid = component.get('finderUuid');
        const collectionFrom = component.get('collectionFrom');
        let selectedExternalApiData = component.get('externalApiData');
        let selectedCollectionData = component.get('selectedCollectionData');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const cmsFilterContainer = elInput.querySelector('.cms-filter-container');

        const cmsExternalAPIContainer = elInput.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = elInput.querySelector(
          '.create-external-api-container',
        );
        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');
        if (collectionName) {
          const response = await getCollectionFields(collectionName, collections);
          selectedCollectionData = response;
        }
        if (selectedCollectionData) {
          if (selectedExternalApiData) {
            if (
              !selectedCollectionData['externalApiId'] &&
              selectedExternalApiData.hasOwnProperty('externalApiId')
            ) {
              selectedCollectionData.externalApiId = selectedExternalApiData.externalApiId;
            }
            if (
              !selectedCollectionData['responseDataMapping'] &&
              selectedExternalApiData.hasOwnProperty('responseDataMapping')
            ) {
              selectedCollectionData.responseDataMapping =
                selectedExternalApiData.responseDataMapping;
            }
            if (
              !selectedCollectionData['bodyDataFrom'] &&
              selectedExternalApiData.hasOwnProperty('bodyDataFrom')
            ) {
              selectedCollectionData.bodyDataFrom = selectedExternalApiData.bodyDataFrom;
            }
            if (
              !selectedCollectionData['sendFormData'] &&
              selectedExternalApiData.hasOwnProperty('sendFormData')
            ) {
              selectedCollectionData.sendFormData = selectedExternalApiData.sendFormData;
            }
          }
          let collectionDataStr = selectedCollectionData
            ? JSON.stringify(selectedCollectionData)
            : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollectionData);
          component.set('selectedCollectionStr', collectionDataStr.toString());
        }
        if (fieldName && collectionName && refTypeFields.includes(collectionFrom)) {
          let fieldsOptions = [];
          if (collectionFrom === 'innerFields') {
            fieldsOptions = innerFieldOptions;
          } else if (collectionFrom === 'userFields') {
            fieldsOptions = userFieldOptions;
          } else if (collectionFrom === 'tenantFields') {
            fieldsOptions = tenantFieldOptions;
          } else if (collectionFrom === 'userSettingsFields') {
            fieldsOptions = userSettingsFieldOptions;
          } else if (selectGetContentFrom.value === 'subTenantFields') {
            fieldsOptions = subTenantFieldOptions;
          }
          selectGetContentFrom.value = collectionFrom;
          let optionHtml = `<option value="" >- Select Field -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'none';
          optionHtml += `${fieldsOptions
            .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectField.value = fieldName;
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid && collectionFrom === 'typesenseCollection') {
          selectGetContentFrom.value = `typesenseCollection`;
          let optionHtml = `<option value="">- Select Typesense Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getTypesenseCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollectionData
            ? selectedCollectionData.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }
          selectExternalApiField.value = '';
        } else if (collectionName && finderUuid) {
          selectGetContentFrom.value = `collections`;
          let optionHtml = `<option value="">- Select Collection -</option>`;
          selectFieldDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';
          cmsFilterContainer.style.display = 'block';
          optionHtml = getCollectionOptionsForSelect(collections);
          selectField.innerHTML = optionHtml;
          selectField.value = collectionName;
          const finderOptions = selectedCollectionData
            ? selectedCollectionData.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');
          if (!filterTrait) {
            component.addTrait(
              {
                type: 'select',
                // label: 'Filter',
                label: false,
                name: 'finderUuid',
                options: finderOptions,
                changeProp: 1,
              },
              { at: component.getTraitIndex('collectionName') + 1 },
            );
          } else {
            filterTrait.set('options', finderOptions);
          }

          const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
          if (!hideWhenEmptyTrait) {
            component.addTrait(
              {
                type: 'checkbox',
                label: 'Hide When Empty',
                name: 'hideWhenEmpty',
              },
              { at: component.getTraitIndex('enableMultiSelect') + 1 },
            );
          }

          selectExternalApiField.value = '';
        }
        // else if (collectionName && collectionFrom === 'browserSession') {
        //   selectGetContentFrom.value = `browserSession`;
        //   let optionHtml = `<option value="">- Select Collection -</option>`;
        //   selectFieldDiv.style.display = 'block';
        //   cmsDataContainer.style.display = 'block';
        //   cmsCreateCollectionContainer.style.display = 'block';
        //   cmsFilterContainer.style.display = 'block';
        //   optionHtml = getCollectionOptionsForSelect(collections);
        //   selectField.innerHTML = optionHtml;
        //   selectField.value = collectionName;
        //   const filterTrait = component.getTrait('finderUuid');
        //   if (filterTrait) {
        //     component.removeTrait('finderUuid');
        //   }
        //   const sessionDataPathTrait = component.getTrait('sessionDataPath');
        //   if (!sessionDataPathTrait) {
        //     component.addTrait(
        //       {
        //         type: 'text',
        //         label: 'Data Path',
        //         name: 'sessionDataPath',
        //         placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
        //         changeProp: 1,
        //       },
        //       { at: component.getTraitIndex('collectionName') + 1 },
        //     );
        //   }

        //   const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
        //   if (hideWhenEmptyTrait) {
        //     component.set('hideWhenEmpty', '');
        //     component.removeTrait('hideWhenEmpty');
        //   }
        //   selectExternalApiField.value = '';
        // }
        else if (collectionName && collectionFrom === 'externalAPIResponse') {
          selectGetContentFrom.value = `externalApiResponse`;
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';

          selectExternalApiFieldDiv.style.display = 'block';
          cmsExternalAPIContainer.style.display = 'block';
          cmsCreateExternalAPIContainer.style.display = 'block';

          selectField.value = collectionName;

          selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          selectExternalApiField.value = selectedCollectionData
            ? selectedCollectionData.externalApiId
            : '';

          const hideWhenEmptyTrait = component.getTrait('hideWhenEmpty');
          if (hideWhenEmptyTrait) {
            component.set('hideWhenEmpty', '');
            component.removeTrait('hideWhenEmpty');
          }
        }
        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsDataLabel.innerHTML = selectGetContentFrom.value
            ? selectGetContentFrom.value === 'collections'
              ? 'Collection'
              : selectGetContentFrom.value === 'typesenseCollection'
              ? 'Typesense Collection'
              : 'Collection Field'
            : '';

          if (collectionName || fieldName || selectField.value || selectExternalApiField.value) {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            }

            if (collectionName && finderUuid && collectionFrom !== 'externalAPIResponse') {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'block';
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepThree');
              cmsFilterContainer.style.display = 'none';
            }
          } else {
            if (collectionFrom === 'externalAPIResponse') {
              if (selectExternalApiField.value) {
                processSteps(
                  cmsProgressStep,
                  true,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              } else {
                processSteps(
                  cmsProgressStep,
                  false,
                  cmsProgressBarContainer,
                  'stepTwo',
                  cmsExternalAPIContainer,
                );
              }
            } else {
              processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepTwo');
            }
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          cmsDataLabel.innerHTML = '';
          selectFieldDiv.style.display = 'none';
          cmsDataContainer.style.display = 'none';
          cmsCreateCollectionContainer.style.display = 'none';
          cmsFilterContainer.style.display = 'none';
          cmsCreateExternalAPIContainer.style.display = 'none';
          cmsExternalAPIContainer.style.display = 'none';
        }
      },
    });
  } else {
    traitManager.addType('browser-storage-setter-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
